import * as React from 'react';
import useWidget from '@Utils/core/useWidget';
import { WidgetId } from '@Utils/edge/constants';
import useDefineDevice from '@Utils/core/hooks/useDefineDevice';
import useMediaQuery from '@Utils/core/hooks/useMediaQuery-v3';
import { ButtonSizes } from '@Utils/shared/components/Button-v3';
import GameGeneratorPromoted from './GameGeneratorPromoted';
import * as Styled from './PromotedSection.styled';
import GeneratorContext from '../../GeneratorContext';

const PromotedSection: React.FC = () => {
  const widgetGeneratorGlobal = useWidget(WidgetId.GeneratorGlobalV3);
  const { isMobileDevice } = useDefineDevice();
  const { isMobileOrTablet } = useMediaQuery();

  const { isGenerated, showErrorMessage } = React.useContext(GeneratorContext);

  if (!isGenerated) {
    return null;
  }

  if (isMobileDevice) {
    return <GameGeneratorPromoted />;
  }

  return (
    <Styled.PromotedSection>
      <Styled.PromotedButton size={ButtonSizes.large} disabled={showErrorMessage}>
        {isMobileOrTablet
          ? widgetGeneratorGlobal.strings.getRaidButton
          : widgetGeneratorGlobal.strings.getRaidPCButton}
      </Styled.PromotedButton>
      <Styled.LearnMoreButton href={widgetGeneratorGlobal.links.url}>
        {widgetGeneratorGlobal.strings.learnMore}
      </Styled.LearnMoreButton>
    </Styled.PromotedSection>
  );
};

export default PromotedSection;
